import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountTenantHistoryQuery(
    $filters: [Filter]
    $companyId: ID!
    $usageUnitId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        UsageUnit(id: $usageUnitId) {
          data: countTenants(options: { filters: $filters })
        }
      }
    }
  }
`
